/* eslint-disable react/no-danger */
import React, { useRef } from 'react';
import Layout from 'src/components/article.layout';
import AuthorisedSwaggerUI from 'src/components/liveapi/authorisedSwaggerUI';
import Collapsible from 'src/components/collapsible/collapsible';
import EndpointPropsBrowser from 'src/components/endpointprops/endpointpropsbrowser';
import { GetStaticPaths, GetStaticProps } from 'next';
import {
  NavigationPage,
  DocumentationPage,
  getDocumentBySlug,
  getAllDocuments,
  getDocumentTree,
  DocumentationVersion,
} from 'src/lib/docs-api';
// import { ListIcon } from '@domain-group/fe-co-icon';

// This could/can use the [..slug] page, but by breaking it up like this, we reduce the download size for all the non-endpoint/non-swagger docs pages
interface ApiReferencePage {
  version: DocumentationVersion;
  operation: string;
  post: DocumentationPage;
  documentList: NavigationPage[];
}

export default function Document({
  version,
  operation,
  post,
  documentList,
}: ApiReferencePage): any {
  const documentationTarget = useRef(null);

  // No operation page has any code samples
  // useEffect(() => {
  //   async function initialiseDocs() {
  //     // initialise interactive documentation elements
  //     // No operation
  //     // if (documentationTarget) {
  //     //   // eslint-disable-next-line prettier/prettier, import/extensions, import/no-unresolved
  //     //   const documentationScripts = (await import('devportal-docs/dist/non-static/latest/docs.min.js')).default;
  //     //   documentationScripts.init({ rootEl: documentationTarget.current });
  //     // }
  //   }
  //   initialiseDocs();
  // });

  return (
    <Layout
      version={version}
      title={post.title}
      description={
        post.description
          ? post.description
          : `Documenting the ${post.title} endpoint on the Domain Developer Portal`
      }
      documentList={documentList}
    >
      <div ref={documentationTarget}>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />

        {post.dataAccessLevelTable ? (
          <>
            <h2 id="data-access">
              <a className="header-anchor" href="#data-access">
                §
              </a>{' '}
              Data Access
            </h2>
            <Collapsible
              heading="Available Data Properties"
              subheading="View available properties based on your data access level"
              expanded={false}
              // expandedIcon={<ListIcon />} collapsedIcon={<ListIcon />}
            >
              <EndpointPropsBrowser
                fieldDefinition={post.dataAccessLevelTable}
              />
            </Collapsible>
          </>
        ) : (
          <></>
        )}
        <h2 id="try-it-now">
          <a className="header-anchor" href="#try-it-now">
            §
          </a>{' '}
          Try It Now
        </h2>
        <AuthorisedSwaggerUI version={version} operation={operation} />
      </div>
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const params = context.params || {};
  const versionParam = params?.version?.toString() as DocumentationVersion;
  const fullDocPath = `apis/${params.package}/references/${params.operation}`;
  const post = getDocumentBySlug(versionParam, fullDocPath.split('/'));
  // const content = post.html;
  return {
    props: {
      version: versionParam,
      operation: params.operation,
      package: params.package,
      post,
      documentList: getDocumentTree(versionParam, fullDocPath),
    },
  };
};

function getVersionPaths(version: DocumentationVersion) {
  const posts = getAllDocuments(version);

  return posts
    .filter((post) => post.path.includes('/references/'))
    .map((post) => ({
      params: {
        package: post.path.split('/')[1],
        operation: post.path.split('/')[3],
        version,
      },
    }));
}

export const getStaticPaths: GetStaticPaths = async () => {
  const versions: DocumentationVersion[] = ['v1', 'v2', 'beta', 'latest'];
  const paths = ([] as any[]).concat(
    ...versions.map((version) => getVersionPaths(version)),
  );
  return {
    paths,
    fallback: false,
  };
};
